import moment from "moment";

export const dateFormatMoment = "YYYY-MM-DDTHH:mm:ss.SSSSSSZ";
const onlyDateFormat = "DD-MM-YYYY";

export function formatDate(date: string, format: string) {
    if (date) {
        return moment(date).format(format).toString();
    }
    return "";
}

export function addDays(date: string, nbDays: number) {
    return moment(date).add(nbDays, "days");
}

export function addYears(date: string, nbYears: number) {
    return moment(date).add(nbYears, "years");
}

export function nbDaysBetweenTwoDates(lshDate: string, rshDate: string) {
    return moment(lshDate).diff(moment(rshDate), "days");
}

export function now() {
    return moment();
}

export function NowDateTime() {
    return moment().format(dateFormatMoment);
}

export function momentDate(dateString: string) {
    return moment(dateString);
}

export function OnlyDateString(dateString: string) {
    return moment(dateString).format(onlyDateFormat);
}

export const compareDatesDescending = (
    date1: string | null,
    date2: string | null
) => {
    const dateA = moment(date1);
    const dateB = moment(date2);

    if (dateA.isBefore(dateB)) {
        return -1;
    }
    if (dateA.isAfter(dateB)) {
        return 1;
    }
    return 0;
};

export const compareDatesAscending = (
    date1: string | null,
    date2: string | null
) => {
    const dateA = moment(date2);
    const dateB = moment(date1);

    if (dateA.isBefore(dateB)) {
        return -1;
    }
    if (dateA.isAfter(dateB)) {
        return 1;
    }
    return 0;
};
